import classNames from 'classnames';
import React, { PureComponent } from 'react';
import styles from './InlineMessage.module.scss';

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: string | React.ReactElement;
  size: 'small' | 'medium';
  type: 'default' | 'neutral' | 'success' | 'info' | 'warning' | 'alert' | 'error';
  className?: string;
  isVisible?: boolean;
  children?: React.ReactNode;
  /** Floating action, typically a button, in the top-right corner */
  action?: React.ReactNode;
  stacked?: boolean;
  noMargin?: boolean;
}

class InlineMessage extends PureComponent<Props> {
  static defaultProps = {
    size: 'medium',
    type: 'default',
    isVisible: true,
  };
  render() {
    const {
      size,
      type,
      stacked,
      noMargin,
      className,
      isVisible,
      title,
      children,
      action,
      ...rest
    } = this.props;
    const containerClass = classNames(
      styles.base,
      styles[type],
      styles[`size-${size}`],
      { [styles.stacked]: stacked, [styles.noMargin]: noMargin },
      className
    );

    if (!isVisible) {
      return null;
    }

    return (
      <div data-testid={`${type}_inline_message`} className={containerClass} {...rest}>
        {!!action && <div className={styles.action}>{action}</div>}
        {title ? <h5>{title}</h5> : false}
        {children}
      </div>
    );
  }
}

export default InlineMessage;
